import { apiGet } from "./client";
import type { Scenario, ScenarioSection } from "../types";

export function getScenarioData(scenarioId: number): Promise<Scenario> {
  return apiGet<Scenario>(`/modelscenario/${scenarioId}/modeldata`);
}

export function getScenarioSections(scenarioId: number): Promise<any> {
  return apiGet<any>(`/modelscenario/${scenarioId}/sections`);
}

export function getSectionData(
  scenarioId: number,
  sectionId: string,
): Promise<ScenarioSection> {
  return apiGet<ScenarioSection>(
    `/modelscenario/${scenarioId}/section/${sectionId}/modeldata`,
  );
}

export function getScenarioWithSensitivity(
  scenarioId: number,
  sensitivityId: number,
): Promise<Scenario> {
  return apiGet<Scenario>(
    `/modelscenario/${scenarioId}/sensitivity/${sensitivityId}/modeldata`,
  );
}

export function getSensitivity(sensitivityId: number): Promise<any> {
  return apiGet<any>(`/sensitivities/${sensitivityId}`);
}

export function getComputeErrors(scenarioId: number): Promise<any[]> {
  return apiGet<any[]>(`/modelscenario/${scenarioId}/compute-errors`);
}

export function getSensitivityComputeErrors(sensitivityId: number): Promise<any[]> {
  return apiGet<any[]>(`/sensitivities/${sensitivityId}/compute-errors`);
}

export function searchScenarioModelData(
  scenarioId: number,
  query: string,
  kind: "Input" | "Output",
): Promise<any> {
  return apiGet<any>(
    `/modelscenario/${scenarioId}/search?query=${encodeURIComponent(query)}&kind=${kind}`,
  );
}
